import React, { useState } from "react";

const Page4 = () => {
  const steps = [
  {
    title: "Solicitação da Mudança",
    content: {
      intro:
        "Nesta etapa, ocorre o registro formal da necessidade de mudança no sistema de MOC. O solicitante descreve:",
      items: [
        "descrição da mudança",
        "a razão da mudança",
        "critério de sucesso",
        "a área ou sistema impactado",
        "o tipo de mudança (permanente, temporária ou emergencial)"
      ],
      outro:
        "A partir desse registro, a mudança passa a ser controlada pelo processo de MOC e não deve ser implementada sem seguir as etapas subsequentes."
    }
  },

  {
    title: "Definição do Escopo",
    content: {
      intro:
        "Aqui são estabelecidos com clareza o que será alterado e o que não será impactado, evitando interpretações incorretas e “desvios de escopo”. São identificados:",
      items: [
        "Equipamentos, sistemas ou processos envolvidos",
        "Documentação a ser atualizada (procedimentos, P&IDs, especificações, isométricos, folha de dados)",
        "Áreas e equipes afetadas (operação, manutenção, contratados)",
        "Se aplica a projetos de capital e mudanças organizacionais (CAM-IMS-000059)"
      ]
    }
  },

  {
    title: "Plant Experiment",
    content: {
      intro:
        "É uma operação realizada para avaliar o impacto de mudanças significativas no processo ou definir limites operacionais, com coleta e registro de dados. Aplica-se a situações como:",
      items: [
        "Operações fora da faixa aprovada",
        "Mudanças de especificação, matéria-prima ou formulação",
        "Reprocessamento de produtos",
        "Modificações relevantes em processos ou instalações"
      ],
      outro:
        "Quando aplicável, deve ser documentado, anexado ao MOC e aprovado pelos especialistas antes da implementação."
    }
  },

  {
    title: "Análise de Riscos e Impactos",
    content: {
      intro:
        "Etapa crítica em que são avaliados os riscos potenciais da mudança. Um checklist no sistema eletrônico auxilia na identificação dos impactos em:",
      items: [
        "PPS: processos e produtos perigosos GHS (PCl₃, P₄, Cl₂, HCl)",
        "Meio Ambiente: emissões, efluentes, resíduos",
        "Qualidade: conformidade e especificações do produto",
        "Saúde e Segurança Ocupacional: exposição química e condições de trabalho",
        "Operação: impactos na operabilidade da planta",
        "Confiabilidade (mecânica, integridade e I&E) – disponibilidade e integridade de equipamentos",
        "Functional Safety (Segurança Funcional): impactos em automação",
        "Facilities: Impactos em edificações e estruturas"
      ],
      outro:
        "Com base nessa avaliação, os riscos são classificados e tratados por meio de medidas de controle antes de a mudança seguir para aprovação."
    }
  },

  {
    title: "Avaliações Técnicas e Especialidades",
    content: {
      intro:
        "As avaliações são conduzidas pelos Especialistas Locais e Técnicos, conforme a natureza da mudança. Podendo envolver áreas como engenharia, processo, automação, manutenção, qualidade e outras especialidades aplicáveis.",
      outro:
        "No sistema eletrônico, cada especialidade possui um checklist específico para garantir que todos os impactos sejam avaliados."
    }
  },

  {
    title: "Aprovação da Mudança",
    content: {
      intro:
        "Na etapa de Aprovação da Mudança, as funções responsáveis avaliam se:",
      items: [
        "os riscos foram corretamente identificados",
        "as medidas de controle são adequadas",
        "a mudança está alinhada aos requisitos legais e corporativos"
      ],
      outro:
        "Somente após a aprovação formal, a mudança pode ser implementada."
    }
  },

  {
    title: "Planejamento da Implementação",
    content: {
      intro:
        "Define como a mudança será executada na prática, incluindo:",
      items: [
        "Sequência de atividades e cronograma",
        "Recursos necessários (humanos, materiais, ferramentas)",
        "Responsáveis pela execução",
        "Condições operacionais durante a intervenção",
        "Atualização de documentação, em red line, disponibilizada no MOC",
        "Necessidade de paradas, testes ou validações",
        "Se aplica Plant Experiment (requer documento descritivo em inglês e português)"
      ]
    }
  },

  {
    title: "Comunicação e Treinamento",
    content: {
      intro:
        "Todos os impactados (operação, manutenção, contratados) devem ser informados e, quando necessário, treinados sobre a mudança. Isso inclui:",
      items: [
        "Leitura e assinatura do MOC no sistema eletrônico",
        "Treinamento formal (se exigido), registrado via lista de presença (CAM-IMS-000037)",
        "Comunicação clara sobre novos riscos, procedimentos e controles"
      ]
    }
  },

  {
    title: "Implementação da Mudança",
    content: {
      intro:
        "Execução da alteração conforme planejado e aprovado. Durante a implementação, deve-se garantir que:",
      items: [
        "Os controles definidos sejam aplicados",
        "As condições de segurança sejam mantidas",
        "A PSSR (Pré-Startup Safety Review) seja realizada antes da partida"
      ]
    }
  },

  {
    title: "Atualização da Documentação",
    content: {
      intro:
        "Após a implementação, toda a documentação impactada e já disponibilizada em red line na etapa de Planejamento da Implementação, deve ser atualizada, conforme o PMF. Isso inclui procedimentos, instruções operacionais, registros e outros documentos aplicáveis.",
      outro:
        "A documentação atualizada garante rastreabilidade e padronização das operações."
    }
  },

  {
    title: "Encerramento do MOC",
    content: {
      intro:
        "Verificação final confirma que todas as etapas foram concluídas:",
      items: [
        "Riscos controlados e resultados avaliados",
        "Documentação permanentemente atualizada",
        "Treinamentos e comunicações registrados",
        "PSSR aprovada e ações pendentes encerradas"
      ],
      outro:
        "Após confirmação, o MOC é formalmente encerrado e arquivado no sistema eletrônico e no PMF."
    }
  }
];

  const [selectedIndex, setSelectedIndex] = useState(0);
  const selected = steps[selectedIndex];

  return (
    <div className="moc-page">
      {/* ESQUERDA */}
      <div className="moc-left" style={{ paddingTop: "160px" }}>
        {steps.map((step, index) => (
          <div
            key={index}
            className={`moc-item ${selectedIndex === index ? "active" : ""}`}
            onClick={() => setSelectedIndex(index)}
          >
            <div className="moc-number">{index + 1}</div>
            <div className="moc-title">{step.title}</div>
            <div className="moc-plus">+</div>
          </div>
        ))}
      </div>

      {/* DIREITA */}
      <div className="moc-right" style={{ paddingTop: "160px" }}>
        <h2>
          {selectedIndex + 1}. {selected.title}
        </h2>

        {/* 🔥 Render inteligente */}
        {typeof selected.content === "string" ? (
          <p>{selected.content}</p>
        ) : (
          <div>
            <p style={{ marginBottom: 12 }}>{selected.content.intro}</p>

          <div>
            {selected.content.intro && (
              <p style={{ marginBottom: 12 }}>{selected.content.intro}</p>
            )}

            {selected.content.items && (
              <ul style={{ marginBottom: 12, paddingLeft: 20 }}>
                {selected.content.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            )}

            {selected.content.outro && <p>{selected.content.outro}</p>}
          </div>

            <p>{selected.content.outro}</p>
          </div>
        )}
      </div>

      <style>{`
        .container{
          width: 100% !important;
        }

        .moc-page {
          display: flex;
          height: 100%;
          overflow: hidden;
        }

        .moc-left {
          width: 50%;
          background: #f1f5f9;
          padding: 30px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          gap: 10px;
          overflow-y: auto;
        }

        .moc-right {
          width: 50%;
          background: #4592C5;
          color: white;
          padding: 40px;
          box-sizing: border-box;
          overflow-y: auto;
        }

        .moc-item {
          display: flex;
          align-items: center;
          background: #d9e2ec;
          border-radius: 25px;
          padding: 12px 15px;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .moc-item:hover {
          background: #cbd5e1;
        }

        .moc-item.active {
          background: #93c5fd;
        }

        .moc-number {
          background: #3b82f6;
          color: white;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          font-weight: bold;
        }

        .moc-title {
          flex: 1;
          font-size: 14px;
        }

        .moc-plus {
          font-size: 18px;
          font-weight: bold;
          color: #3b82f6;
        }

        .moc-right h2 {
          margin-bottom: 20px;
        }

        .moc-right p {
          line-height: 1.6;
        }

        .moc-right ul {
          line-height: 1.6;
        }

        @media (max-width: 768px) {
          .moc-page {
            flex-direction: column;
          }

          .moc-left {
            width: 100%;
            height: 40%;
            padding: 20px;
          }

          .moc-right {
            width: 100%;
            height: 60%;
            padding: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default Page4;